import PropTypes from "prop-types";

const BASE_CLASS =
  "h-9 w-9 rounded border border-white/30 bg-white/10 text-lg font-semibold text-white transition hover:bg-white/20 flex items-center justify-center";

export default function ModalCloseX({
  onClick,
  className = "",
  disabled = false,
  ariaLabel = "Close",
  title,
}) {
  const mergedClassName = `${BASE_CLASS} ${className}`.trim();
  const resolvedTitle = title || ariaLabel;

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title={resolvedTitle}
      onClick={onClick}
      disabled={disabled}
      className={mergedClassName}
    >
      <span aria-hidden="true" className="text-xl leading-none">
        X
      </span>
    </button>
  );
}

ModalCloseX.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
};
